import { connect } from 'react-redux'
import MediaUpload from '../components/MediaUpload'
import { loadingActions } from 'store/loader'

const mapStateToProps = (state, ownProps) => {
  const { loading } = state
  const { mediaUpload: mediaUploadLoading } = loading
  return {
    mediaUploadLoading,
    ...ownProps,
  }
}

const mapDispatchToProps = {
  stopMediaUploadLoader: () => loadingActions.stopLoader(true, 'mediaUpload'),
}

export default connect(mapStateToProps, mapDispatchToProps)(MediaUpload)
